module.exports = "/_next/static/images/incident-response-plan-development-b10f8f42ca5257611bdad8b955a7b3a7.webp";